/* Sitewide infinite scroll for Shopify product grids (Fashionopolism friendly)
   - Uses a UNIQUE sentinel class to avoid theme/app interference
   - Works on Collection templates & Featured Collection sections
   - Hard-stops at the end and removes its sentinel so it can’t re-fire
*/
(function initInfiniteSiteGrids(){
  if (window.__InfiniteSiteGridsInit) return;
  window.__InfiniteSiteGridsInit = true;

  const GRID_SELECTORS = [
    '#main-collection-product-grid',
    '.featured__collection',
    '.productgrid--items'
  ];

  const TILE_SELECTORS = [
    '.js-product-listing',
    '.grid-product',
    '.productgrid--item'
  ];

  const UNIQUE_SENTINEL_CLASS = 'mfk-infinite-sentinel'; // <— NEW unique class

  // Clean up any old theme/app sentinels & messages BEFORE we start
  try {
    document.querySelectorAll('.infinite-sentinel').forEach(n => n.remove()); // legacy theme sentinel
    // also remove any literal “Could not load more”
    document.querySelectorAll('body *').forEach(n=>{
      if (n.childElementCount===0 && /could not load more/i.test(n.textContent||'')) {
        const p = n.parentElement;
        n.remove();
        if (p && p.childElementCount===0) p.remove();
      }
    });
  } catch(e){}

  const grids = findGrids();
  if (!grids.length) return;
  grids.forEach(setupGrid);

  function findGrids(){
    const list = [];
    GRID_SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(n => list.push(n));
    });
    return Array.from(new Set(list));
  }

  function setupGrid(grid){
    let ended = false;
    let loading = false;

    const container = grid.closest('section, .shopify-section, .collection__page, .grid__wrapper') || document;
    const pagination = findPagination(container);
    if (!pagination) return;

    let next = findNextLink(pagination);
    if (!next) return;

    hidePagination(pagination);

    // create a brand-new, unique sentinel right after the grid
    const sentinel = makeSentinelAfter(grid);

    const io = new IntersectionObserver(async entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting || loading || ended) continue;

        if (!next) { finish(); return; }

        loading = true;
        sentinel.textContent = 'Loading…';

        try {
          const { items, newNext, done } = await fetchNextItems(next.href, grid);
          if (items.length) items.forEach(el => grid.appendChild(el));
          next = newNext || null;

          if (done || !next) {
            sentinel.textContent = '';    // no text
            finish(10);                   // remove almost immediately
          } else {
            sentinel.textContent = '';    // keep it empty while waiting
          }
        } catch (_err) {
          // Treat any error like a natural end: no error text, just remove sentinel
          sentinel.textContent = '';
          finish(10);
        } finally {
          loading = false;
        }
      }
    }, { rootMargin: '1000px 0px 0px 0px' });

    io.observe(sentinel);

    function finish(delayMs){
      if (ended) return;
      ended = true;
      const hide = () => {
        try { io.unobserve(sentinel); } catch(e){}
        try { io.disconnect(); } catch(e){}
        if (sentinel && sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
      };
      if (typeof delayMs === 'number') setTimeout(hide, delayMs); else hide();
    }
  }

  function findPagination(scope){
    return scope.querySelector('.pagination, [data-pagination]') || null;
  }

  function findNextLink(scope){
    return (
      scope.querySelector('a[rel="next"]') ||
      scope.querySelector('.pagination .pagination-next') ||
      scope.querySelector('.pagination__item--next a') ||
      scope.querySelector('a.pagination__next') ||
      null
    );
  }

  function hidePagination(node){
    node.style.visibility = 'hidden';
    node.style.height = '0';
    node.style.overflow = 'hidden';
    node.style.margin = '0';
    node.style.padding = '0';
  }

  function makeSentinelAfter(grid){
    const sentinel = document.createElement('div');
    sentinel.className = UNIQUE_SENTINEL_CLASS;             // <— unique class
    sentinel.style.clear = 'both';
    sentinel.style.width = '100%';
    sentinel.style.textAlign = 'center';
    sentinel.style.padding = '12px 0';
    sentinel.setAttribute('aria-live', 'polite');
    grid.insertAdjacentElement('afterend', sentinel);
    return sentinel;
  }

  async function fetchNextItems(url, currentGrid){
    let html = '';
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return { items: [], newNext: null, done: true };
      html = await res.text();
    } catch (_e) {
      return { items: [], newNext: null, done: true };
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');

    // try matching the same grid first
    let newGrid = null;
    for (const sel of GRID_SELECTORS) {
      if (currentGrid.matches(sel)) { newGrid = doc.querySelector(sel); if (newGrid) break; }
    }
    if (!newGrid) {
      for (const sel of GRID_SELECTORS) { newGrid = doc.querySelector(sel); if (newGrid) break; }
    }

    let items = [];
    if (newGrid) {
      let tiles = [];
      for (const t of TILE_SELECTORS) tiles = tiles.concat(Array.from(newGrid.querySelectorAll(t)));
      if (!tiles.length) tiles = Array.from(newGrid.children);
      items = tiles.filter(n => n && n.nodeType === 1);
    }

    const newNext =
      doc.querySelector('a[rel="next"]') ||
      doc.querySelector('.pagination .pagination-next') ||
      doc.querySelector('.pagination__item--next a') ||
      doc.querySelector('a.pagination__next') ||
      null;

    const done = !newNext || items.length === 0;
    return { items, newNext, done };
  }
})();
